<template>
    <b-modal :no-close-on-backdrop="true"
        @hidden="resetData"
        id="modal-Create"
        title="Edit Budget" 
        hide-footer 
        :centered="true"
        v-model="open">
        <b-form class="pb-20">
            <b-row>
                <b-col md="12" class="mb-16">
                    <gofix-form-dropdown
                        label="Client Contract"
                        vLabel="contract_name"
                        :filterable="false"
                        required
                        disabled
                        :reduce="contract => contract.id"
                        :options="contracts"
                        v-model="data.client_contract_id"
                        @search="searchContract">
                    </gofix-form-dropdown>
                </b-col>
                <b-col cols="12" class="mb-16">
                    <gofix-form-dropdown
                        label="Department Code - Property"
                        vLabel="dept_code"
                        :filterable="false"
                        required
                        :options="deptCodes"
                        v-model="data.department_code"
                        @search="searchDeptCode">
                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                            <span class="text-hidden-one-row">{{ option.dept_code }}</span>
                        </template>
                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                            <div class="maintOption">
                                <span>{{ `${option.root_path} - ${option.dept_code}` }}</span>
                            </div>
                        </template>
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="12" class="mb-16">
                   <gofix-form-input-date label="Financial Year Start" desc="" v-model="data.financial_year_start">
                    </gofix-form-input-date>
                </b-col>
                <b-col md="12" class="mb-16">
                   <gofix-form-dropdown
                        label="Status"
                        :filterable="false"
                        :required="true"
                        :disabled="data.status == 'Approved'"
                        :reduce="option => option.value"
                        v-model="data.status"
                        :options="listStatus">
                    </gofix-form-dropdown>
                </b-col>
            </b-row>
        </b-form>
        <b-button-group class="d-block text-right">
            <gofix-button label="SUBMIT" @click="saveData" :loading="loading" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>

<script>
    import moment from 'moment'
    export default {
        name: 'modal-edit-budget',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            item: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                open: false,
                loading: false,
                timer: {
                    store: null,
                    contract: null,
                    deptCode: null
                },
                contracts: [],
                deptCodes: [],
                listStatus: [
                    {
                        label: 'Draft',
                        value: 'Draft'
                    },
                    {
                        label: 'Approved',
                        value: 'Approved'
                    }
                ],
                data: {
                    client_contract_id: null,
                    financial_year_start: null,
                    status: 'Draft',
                }
            }
        },
        watch: {
            value: function(val) {
                this.open = val;
                if(val) {
                    this.data = Object.assign(this.data, this.item);
                    this.data.financial_year_start = new Date(this.data.financial_year_start);
                    this.data.financial_year_end = new Date(this.data.financial_year_end);
                }
            },
            open: function(val) {
                this.$emit('input', val);
            },
            "data.client_contract_id": function(val) {
                if(val) {
                    this.getDeptCode();
                } else {
                    this.deptCodes = [];
                }
            }
        },
        created() {
            this.getContract();
        },
        methods: {
            saveData() {
                if (this.timer.store) {
                    clearTimeout(this.timer.store);
                    this.timer.store = null;
                }
                this.timer.store = setTimeout(() => {
                    if(!this.data.department_code) {
                        return this.$alertNotification("Department code is required", "danger");
                    }

                    if(!this.data.financial_year_start) {
                        return this.$alertNotification("Financial year start is required", "danger");
                    }

                    if(this.loading) return;
                    this.loading = true;
                    let request = {
                        id: this.data.id,
                        client_contract_id: this.data.client_contract_id,
                        finance_linking_id: this.data.department_code.id,
                        property_id: this.data.property_id,
                        dept_code: this.data.department_code.dept_code,
                        financial_year_start : moment(this.data.financial_year_start).format('YYYY-MM-DD'),
                        status: this.data.status,
                    }
                    this.$store.dispatch("BudgetAllocationController/updateHeaderItem", request)
                    .then(response => {
                        this.loading = false;
                        this.open = false;
                        this.$alertNotification(this.$notificationV2('editing', 'budget_header'));
                        this.$emit('saveSuccess');
                     })
                    .catch(error => {
                        this.loading = false;
                        if(error.response && error.response.data.error.message.error) {
                            return this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    })
                }, 300);
            },
            resetData() {
                this.data.client_contract_id   = null;
                this.data.financial_year_start = null;
            },
            getContract(filter = null, limit = 100) {
                this.$store.dispatch(`ContractController/getListClientContractsSearch`, [1, filter, limit])
                    .then(response => {
                        this.contracts = response.data;
                    })
            },
            searchContract(search, loading) {
                this.contracts = []
                loading(true);
                if (this.timer.contract) {
                    clearTimeout(this.timer.contract);
                    this.timer.contract = null;
                }
                this.timer.contract = setTimeout(() => {
                    try {
                        this.getContract({
                            contract_name: search
                        });
                        loading(false)
                    } catch (error) {
                        loading(false)
                    }
                }, 500);
            },
            getDeptCode(search = '') {
                let request = {
                    filter: {
                        dept_code: search,
                        client_contract_id: this.data.client_contract_id
                    },
                    limit: -1,
                    page: 1,
                    sortColumn: 'dept_code',
                    sortDirection: 'ASC',
                }
                this.$store.dispatch("PropertyDepartmentController/getItems", request)
                .then(response => {
                    this.deptCodes = response.items;
                })
                .catch(err => {})
            },
            searchDeptCode(search, loading) {
                this.deptCodes = []
                loading(true);
                if (this.timer.deptCode) {
                    clearTimeout(this.fmCode.deptCode);
                    this.timer.deptCode = null;
                }
                this.timer.deptCode = setTimeout(() => {
                    try {
                        this.getDeptCode(search);
                        loading(false)
                    } catch (error) {
                        loading(false)
                    }
                }, 500);
            },
        }
    }
</script>